export default __webpack_public_path__ + "static/media/laval15.37fc1330.jpg";